<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-12-09 09:07:46
 * @LastEditTime : 2025-12-17 14:39:46
 * @LastEditors  : yangxr
 * @Description  : 欠供复审
 * @FilePath     : \icps_fb\src\views\platform\ICPS\internetSales\supplyManagement\overdueSupplyReview.vue
-->
<template>
    <div class="pages_content table">
        <el-container>
            <el-header>
                <breaDcrumb />
            </el-header>
            <el-main>
                <div>
                    <el-collapse-transition>
                        <div v-show="showCardNav">
                            <div class="search">
                                <span style="display: inline-block; margin-bottom: 10px">
                                    <span style="margin-right: 12px">时间</span>
                                    <el-date-picker v-model="tableParam.dataMouth" style="width: 150px;" type="month"
                                        unlink-panels value-format="yyyy-MM" start-placeholder="开始时间"
                                        end-placeholder="结束时间"></el-date-picker>
                                </span>
                                <el-button icon="el-icon-search" style="margin-left: 24px" size="medium" class="bottom_all"
                                    @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                            </div>
                        </div>
                    </el-collapse-transition>
                    <div class="hr"></div>
                    <div class="card">
                        <div v-loading="tableLoading" class="card_info" :style="style">
                            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                                border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
                                <template v-for="(item, index2) in table">
                                    <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                                        :width="item.width">
                                        <template slot-scope="scope">
                                            <span v-if="item.label == '操作'">
                                                <el-button size="mini" class="bottom_one"
                                                    @click="lookDetail(scope.row)">查看</el-button>
                                            </span>
                                            <span v-else-if="item.label == '审核状态'">
                                                <span v-if="scope.row.approvalStatus == 0">待提交</span>
                                                <span v-if="scope.row.approvalStatus == 1">已审批</span>
                                                <span v-if="scope.row.approvalStatus == 3">审批中</span>
                                                <span v-if="scope.row.approvalStatus == 4">审批失败</span>
                                            </span>
                                            <span v-else>{{ scope.row[item.prop] }}</span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                </div>
            </el-main>
            <div class="card_bottom">
                <div class="card_bottom_left">
                    <div class="top_page_totle">总共{{ total }}条</div>
                    <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
                        :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
                        :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
                </div>
                <div>
                    <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                        @click="gettableData">刷新</el-button>
                </div>
            </div>
        </el-container>
    </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { overdueSupplyQueryPage as queryPage } from "@/api/internetSales/supplyManagement.js";
export default {
    components: {
    },
    mixins: [mixin],
    data() {
        return {
            table: [
                { label: "日期", prop: "dataMouth", status: true, width: "220" },
                { label: "风控类型", prop: "riskControlType", status: true, width: "220" },
                { label: "审核状态", prop: "approvalStatus", status: true, width: "auto" },
                { label: "操作", prop: "productionSite", status: true, width: "auto" },
            ],
            queryPage: queryPage,
            tableData: [],
            pagesType: 0,
            tableParam: {
                page: 1,
                pageSize: 10,
                dataMouth: "",//筛选条件：时间
            },
            dataType:1,
        };
    },
    watch: {
    },
    async created() {
        this.gettableData();
    },
    methods: {
        choose(num) {
            this.dataType = num
        },
        lookDetail(row) {
            this.$router.push({ name: 'overdueSupplyReviewDetail', query: { id: row.id, approvalStatus: row.approvalStatus } })
        },
        sizeChange(value) {
            this.tableParam.pageSize = value;
            this.gettableData();
        },
        /*重置数据,此方法必须存在，并且方发只重置条件*/
        init() {
            this.tableParam = this.$options.data().tableParam
            this.gettableData();
        },
    },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
    width: 240px;
}

.table_link {
    margin: 0 10px;
    color: $bg_color;
    cursor: pointer;
}

.table_link:hover {
    opacity: 0.8;
}

.textCss {
    display: flex;
    /* 核心1：开启Flex */
    align-items: center;
    text-align: center;
    /* 核心属性 */
}
</style>
  